import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowsExpand = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M30 9H21V11H27.586L21.293 17.293L22.707 18.707L29 12.414V19H31V10C31 9.447 30.552 9 30 9Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.707 22.707L17.293 21.293L11 27.586V21H9V30C9 30.553 9.448 31 10 31H19V29H12.414L18.707 22.707Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgArrowsExpand);
export default ForwardRef;
